import { State } from "../../../state/store";
import { useSelector } from "react-redux";
import { DiseaseCategory } from "../../../domain/disease_knowledge/DiseaseCategory";
import { Disease } from "../../../domain/disease_knowledge/Disease";
import { DiseaseDetail } from "../../../domain/disease_knowledge/DiseaseDetail";
import { Watch } from "../../../domain/disease_knowledge/Watch";
import { AssessmentCheckpoint } from "../../../domain/disease_knowledge/AssessmentCheckpoint";
import { SuggestingService } from "../../../domain/disease_knowledge/SuggestingService";

export const useDiseases = (diseaseId: string): DiseaseDetail | null => {
    const responseJson = useSelector((state: State) => state.diseaseKnowledge.diseases[diseaseId]);
    
    return responseJson ? new DiseaseDetail(
        new Disease(
            responseJson.disease.id,
            responseJson.disease.name),
        new DiseaseCategory(
            responseJson.disease.category.id,
            responseJson.disease.category.name),
        responseJson.disease.description,
        responseJson.disease.abstractDiseases,
        responseJson.disease.symptoms,
        responseJson.disease.misleadingDiseases,
        new Watch(
            responseJson.disease.watch.medicines,
            responseJson.disease.watch.meals,
            responseJson.disease.watch.lifestyleAndEnvironments,
            responseJson.disease.watch.carestaffs,
            responseJson.disease.watch.others),
        new AssessmentCheckpoint(
            responseJson.disease.assessmentCheckpoint.impairments,
            responseJson.disease.assessmentCheckpoint.activities,
            responseJson.disease.assessmentCheckpoint.participations,
            responseJson.disease.assessmentCheckpoint.environments,
            responseJson.disease.assessmentCheckpoint.personals),
        responseJson.disease.suggestingServices.map(suggestingService =>
            new SuggestingService(
                suggestingService.title,
                suggestingService.detail
            )),
        responseJson.disease.advices,
    ) : null;
};
